/* flatoo product thumbnails: Slick retains image/variant synchronization;
   only the thumbnail track becomes native horizontal scrolling. */
(function(){
 'use strict';
 var processed = new WeakSet();
 var mouseDragBound = new WeakSet();

 // Desktop mouse dragging for the native Slick thumbnail scroll list.
 // Touch and trackpad use the browser's original scrolling behavior.
 function installMouseDrag(list){
   if(mouseDragBound.has(list))return;
   mouseDragBound.add(list);
   var drag=null,frame=0,blockClickUntil=0;

   function cancelMomentum(){
     if(frame){cancelAnimationFrame(frame);frame=0;}
     list.classList.remove('flatoo-thumb-dragging');
   }
   function momentum(speed){
     // Pixels per millisecond; a short glide makes mouse scrolling feel natural.
     if(!list.isConnected || Math.abs(speed)<0.07 ||
        (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)){
       cancelMomentum();return;
     }
     var velocity=Math.max(-1.6,Math.min(1.6,speed));
     var last=performance.now(),steps=0;
     function tick(now){
       frame=0;
       if(!list.isConnected){cancelMomentum();return;}
       var dt=Math.min(32,now-last);
       last=now;
       var prev=list.scrollLeft;
       list.scrollLeft=prev+velocity*dt;
       velocity*=Math.pow(0.84,dt/16);
       steps+=dt;
       if(steps<380 && Math.abs(velocity)>0.04 && Math.abs(list.scrollLeft-prev)>0.15){
         frame=requestAnimationFrame(tick);
       }else{
         cancelMomentum();
       }
     }
     frame=requestAnimationFrame(tick);
   }
   function stopDrag(event,allowMomentum){
     if(!drag || (event&&event.pointerId!==drag.id))return;
     var state=drag;
     drag=null;
     if(!state.moved)return;
     blockClickUntil=performance.now()+170;
     try{if(list.hasPointerCapture(state.id))list.releasePointerCapture(state.id);}catch(e){}
     if(allowMomentum){momentum(state.speed);}else{cancelMomentum();}
   }
   list.addEventListener('pointerdown',function(event){
     if(event.pointerType!=='mouse' || event.button!==0 || !event.isPrimary)return;
     cancelMomentum();
     if(list.scrollWidth<=list.clientWidth+3)return;
     drag={id:event.pointerId,x:event.clientX,y:event.clientY,left:list.scrollLeft,
           lastX:event.clientX,lastTime:performance.now(),speed:0,moved:false};
   },{passive:true});

   list.addEventListener('pointermove',function(event){
     if(!drag||event.pointerId!==drag.id)return;
     var dx=event.clientX-drag.x;
     var dy=event.clientY-drag.y;
     if(!drag.moved){
       if(Math.abs(dx)<7 || Math.abs(dx)<Math.abs(dy)*1.2)return;
       drag.moved=true;
       list.classList.add('flatoo-thumb-dragging');
       try{list.setPointerCapture(event.pointerId);}catch(e){}
     }
     if(event.cancelable)event.preventDefault();
     list.scrollLeft=drag.left-dx;
     var now=performance.now(),elapsed=now-drag.lastTime;
     if(elapsed>=8){
       var instant=-(event.clientX-drag.lastX)/elapsed;
       drag.speed=drag.speed*0.35+instant*0.65;
       drag.lastX=event.clientX;
       drag.lastTime=now;
     }
   },{passive:false});

   list.addEventListener('pointerup',function(event){stopDrag(event,true);});
   list.addEventListener('pointercancel',function(event){stopDrag(event,false);});
   list.addEventListener('lostpointercapture',function(event){stopDrag(event,false);});
   window.addEventListener('pointerup',function(event){stopDrag(event,true);},{passive:true});
   // Suppress only the synthetic click after dragging. Normal mouse clicks
   // and keyboard activation of individual thumbnails remain functional.
   list.addEventListener('click',function(event){
     if(event.detail>0 && performance.now()<blockClickUntil){
       event.preventDefault();
       event.stopImmediatePropagation();
     }
   },true);
   list.addEventListener('dragstart',function(event){
     if(event.target.closest('img,.productView-thumbnail-link'))event.preventDefault();
   });
 }
 function scrollerOf(el){return el&&el.querySelector('.slick-list');}
 function currentSlide(carousel){
   return carousel.querySelector('.slick-slide.slick-current:not(.slick-cloned)') ||
     carousel.querySelector('.slick-slide.slick-current');
 }
 function centerSelected(root,behavior){
   var rail=root.querySelector('.productView-for.slick-initialized');
   var list=scrollerOf(rail);
   if(!rail||!list)return;
   var selected=currentSlide(rail);
   if(!selected)return;
   var target=selected.offsetLeft-(list.clientWidth-selected.getBoundingClientRect().width)/2;
   var left=Math.max(0,Math.min(target,list.scrollWidth-list.clientWidth));
   list.scrollTo({left:left,behavior:behavior||'auto'});
 }
 function install(root){
   if(!root.classList.contains('flatoo-pdp-refresh'))return false;
   var rail=root.querySelector('.productView-thumbnail-wrapper .productView-for');
   var list=scrollerOf(rail);
   if(!rail||!rail.classList.contains('slick-initialized')||!list)return false;
   var $=window.jQuery||window.$;
   if(!$||!$.fn||typeof $.fn.slick!=='function')return false;
   installMouseDrag(list);
   if(processed.has(rail)&&list.dataset.flatooNativeThumbs==='true')return true;
   // Disable Slick's touch handlers so iOS/Android momentum scrolling is not interrupted.
   try{
     $(rail).slick('slickSetOption','swipe',false,false);
     $(rail).slick('slickSetOption','touchMove',false,false);
     $(rail).slick('slickSetOption','draggable',false,false);
   }catch(error){return false;}
   list.dataset.flatooNativeThumbs='true';
   if(!processed.has(rail)){
     processed.add(rail);
     var main=root.querySelector('.productView-nav');
     if(main){
       $(main).on('afterChange.flatooThumbs',function(){
         window.requestAnimationFrame(function(){centerSelected(root,'smooth');});
       });
     }
     $(rail).on('afterChange.flatooThumbs',function(){
       window.requestAnimationFrame(function(){centerSelected(root,'smooth');});
     });
     $(rail).on('reInit.flatooThumbs init.flatooThumbs',function(){
       window.requestAnimationFrame(function(){install(root);});
     });
     // The theme uses <a role="button"> for thumbnail selection. Keep keyboard support.
     rail.addEventListener('keydown',function(event){
       if(event.key!=='Enter'&&event.key!==' ')return;
       var link=event.target.closest('.productView-thumbnail-link');
       if(!link)return;
       event.preventDefault();
       link.click();
     });
   }
   rail.querySelectorAll('.productView-thumbnail-link').forEach(function(link){
     if(!link.hasAttribute('tabindex'))link.setAttribute('tabindex','0');
   });
   centerSelected(root,'auto');
   return true;
 }
 function boot(root){
   if(install(root))return;
   var parent=root.querySelector('.productView-thumbnail-wrapper');
   if(!parent)return;
   var checkPending=false;
   var observer=new MutationObserver(function(){
     if(checkPending)return;
     checkPending=true;
     requestAnimationFrame(function(){
       checkPending=false;
       if(install(root))observer.disconnect();
     });
   });
   observer.observe(parent,{childList:true,subtree:true});
   if(install(root))observer.disconnect();
   // Avoid retaining observers indefinitely if a theme variant has no carousel.
   window.addEventListener('pagehide',function(){observer.disconnect();},{once:true});
 }
 function init(){
   document.querySelectorAll('[data-section-type="product"].flatoo-pdp-refresh').forEach(boot);
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
 else init();
 document.addEventListener('shopify:section:load',init);
})();
